// Business rules for the tax questionnaire pages. Mirrors TaxQuestionnaireRules.java on the API.

export const STATUS_NEW = 'new';
export const STATUS_SUBMITTED = 'submitted';
export const STATUS_NOT_ENGAGE = 'submitted - not engage';
// Set in AX once AAS has completed an engaged questionnaire.
export const STATUS_COMPLETE = 'complete';

export const ENGAGE = 'Engage';
export const NOT_ENGAGE = 'Not Engage';

export const REFUND_DIRECT_DEPOSIT_US = 'Bank transfer US';
export const REFUND_CHEQUE = 'US Tax Refund Cheque';

export const ACKNOWLEDGED = 'Yes';

// Mailing-country rule predates the 2027 residency rule and is kept for existing records.
const DIRECT_DEPOSIT_ONLY_MAILING_COUNTRIES = ['Singapore', 'Malaysia'];
// UAE is intentionally excluded.
const DIRECT_DEPOSIT_ONLY_TAX_RESIDENCIES = ['SGP', 'MYS', 'SG', 'MY'];

export const isPendingAction = (questionnaire) => {
    const status = questionnaire?.Status?.toLowerCase() ?? '';
    return status === '' || status === STATUS_NEW;
};

export const getEngagement = (questionnaire) => {
    const status = questionnaire?.Status?.toLowerCase();
    if (status === STATUS_NOT_ENGAGE) {
        return NOT_ENGAGE;
    }
    if (status === STATUS_SUBMITTED || status === STATUS_COMPLETE) {
        return ENGAGE;
    }
    return '';
};

export const getQuestionnaireStatus = (questionnaire, now = new Date()) => {
    if (isPendingAction(questionnaire)) {
        const dueDate = questionnaire?.DueDate ?? '';
        const overdue = dueDate !== '' && !dueDate.includes('1900') && now > new Date(dueDate);
        return { label: overdue ? 'Overdue' : 'Pending Action', pending: true };
    }
    if (questionnaire?.Status?.toLowerCase() === STATUS_COMPLETE) {
        return { label: 'Complete (Engage)', pending: false };
    }
    return { label: getEngagement(questionnaire) === NOT_ENGAGE ? 'Submitted (Not Engage)' : 'Submitted (Engage)', pending: false };
};

export const hasOutstandingShortfall = (questionnaire) => Number(questionnaire?.TotalTaxFilingFeeShortfall) > 0;

export const getShortfallStatus = (questionnaire) => hasOutstandingShortfall(questionnaire)
    ? { label: 'Pending Payment', pending: true }
    : { label: 'Paid', pending: false };

export const getCurrentTaxFilingYear = (questionnaires) => {
    const years = (questionnaires ?? []).map((questionnaire) => questionnaire.TaxFilingYear);
    return years.length > 0 ? Math.max(...years) : null;
};

// Default view: the latest tax filing year only. Show All reveals the previous years.
export const getVisibleQuestionnaires = (questionnaires, showAll) => {
    if (showAll) {
        return questionnaires ?? [];
    }
    const currentYear = getCurrentTaxFilingYear(questionnaires);
    return (questionnaires ?? []).filter((questionnaire) => questionnaire.TaxFilingYear === currentYear);
};

export const isUSDirectDepositOnly = (questionnaire) =>
    DIRECT_DEPOSIT_ONLY_MAILING_COUNTRIES.includes(questionnaire?.TaxMailingCountry)
    || DIRECT_DEPOSIT_ONLY_TAX_RESIDENCIES.includes(questionnaire?.CountryOfTaxResidency);

export const isAcknowledged = (value) => value === ACKNOWLEDGED;

// Same rule as TaxQuestionnaireService.getLatestNewTaxFilingYear: the banner shows only while a questionnaire is still New.
export const getLatestNewTaxFilingYear = (questionnaires) => {
    const years = (questionnaires ?? [])
        .filter((questionnaire) => questionnaire?.Status?.toLowerCase() === STATUS_NEW)
        .map((questionnaire) => questionnaire.TaxFilingYear);
    return years.length > 0 ? Math.max(...years) : null;
};

export const getLocalizedContent = (content, lang) => {
    switch (lang) {
        case 'Traditional Chinese':
        case 'zh_HK':
            return content?.contentTC;
        case 'Simplified Chinese':
        case 'zh_CN':
            return content?.contentSC;
        case 'Japanese':
        case 'jp':
            return content?.contentJA;
        default:
            return content?.contentEN;
    }
};
